import { useEffect, useState } from 'react';
import CreatableSelect from 'react-select/creatable';
import { beautify } from '../../../helpers/str';

const FormControlChips = (props) => {
    const { item, onChipsChange, value, className, theme } = props;
    const options = [];
    const [valueOption, setValueOption] = useState([]);

    const initValueOptions = () => {
        if (typeof value === 'string') {
            const tmp = {
                value: value.toLowerCase(),
                label: beautify(value.toLowerCase()),
            };
            setValueOption(tmp && tmp.value ? tmp : []);
        } else if (Array.isArray(value)) {
            const values = [];
            value.forEach((valueItem) => {
                const tmp = {
                    value: valueItem.toLowerCase(),
                    label: beautify(valueItem.toLowerCase()),
                };
                if (tmp && tmp.value) {
                    values.push(tmp);
                }
            });
            setValueOption(values || []);
        } else {
            setValueOption(value && value.value ? value : []);
        }
    };

    useEffect(() => {
        initValueOptions();
    }, [value]);
    return (
        <>
            <CreatableSelect
                placeholder={`Enter ${item.name}...`}
                theme={(t) => ({ ...t, ...theme })}
                name={item && item.name ? item.name : 'select'}
                value={valueOption}
                options={options}
                className={`${className || 'me-2 w-100'}`}
                closeMenuOnSelect={!item.multi}
                isMulti={true}
                onChange={(option) => onChipsChange(item.name, option)}
            />
        </>
    );
};

export default FormControlChips;
